import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import style from "./style.vue";
import { EmpServiceAPIActions } from "@/services/empService";
import { appEnvConfig } from "@/configs/appConfigs";
import baseAPIService from "@/services/base/baseAPIService";
import { globalElement } from "@/library/utils/globalElement";
import { Functions } from "@/library/utils/functions";

export const morentupian = "https://ssl-picture.tenyun.runsasoft.com/morentupian.jpg";
export enum OrderCenterType {
	DAIFUKUAI = 1,
	DAFAHUO,
	DAISHOUHUO,
	YIWANGCHENG,
	YITUIKUAN,
}
export const orderCenter = [
	{ type: OrderCenterType.DAIFUKUAI, value: "待付款" },
	{ type: OrderCenterType.DAFAHUO, value: "待发货" },
	{ type: OrderCenterType.DAISHOUHUO, value: "待收货" },
	{ type: OrderCenterType.YIWANGCHENG, value: "已完成" },
	{ type: OrderCenterType.YITUIKUAN, value: "退款/售后" },
];
@Component({
	components: {},
	mixins: [style],
})
export default class Order extends Vue {
	@Prop({ default: () => {} })
	value: DisplayOrderData;

	@Prop({ default: false })
	disabled: boolean;

	@Prop({ default: 1 })
	themeCode: number;

	data: DisplayOrderData = {};

	tokenData: ItemObject = {
		Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
	};

	imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	@Watch("value", { deep: true, immediate: true })
	watchValue(n, o) {
		if (JSON.stringify(n) !== JSON.stringify(o)) {
			this.data = n;
		}
	}

	/**
	 * 图片上传成功回调
	 */
	uploadSuccess(res, index) {
		this.data.desc.list[index].url = res.content;
		this.$emit("input", this.data);
	}

	/**
	 * 图片上传之前的格式验证
	 * @param file
	 * @returns {boolean}
	 */
	public beforeAvatarUpload(file) {
		const isJPG = file.type === "image/jpeg";
		const isPNG = file.type === "image/png";
		const isGIF = file.type === "image/gif";
		const isLt300K = file.size / 1024 <= 300;
		if (!isJPG && !isPNG && !isGIF) {
			globalElement.message.error("上传图片只支持 JPG/PNG/GIF 格式!");
		}
		if (!isLt300K) {
			globalElement.message.error("上传图片大小不能超过 300K!");
		}
		return (isJPG || isPNG || isGIF) && isLt300K;
	}

	render(h) {
		return (
			<div class="order-edit" key={this.data.sort}>
				<el-form disabled={this.disabled} ref="form">
					{this.data.desc.list.map((v, index) => {
						return (
							<el-form-item class="inline-block" style={`margin-right: ${this.data.desc.list[index + 1] ? 12 : 0}px;background: ${this.themeCode > 3 ? "#181818" : ""}`} key={index}>
								<div style={`background-image: url(${v.url || morentupian})`} class="img-div">
									<el-upload
										class="upload-order-center"
										headers={this.tokenData}
										action={this.imgTpConfig}
										data={{ corpId: baseAPIService.resolveCorpId() }}
										showFileList={false}
										style={`color: ${this.themeCode > 3 ? "#000000" : "#ffffff"}`}
										{...{
											props: {
												"on-success": (val) => this.uploadSuccess(val, index),
												"on-error": () => {
													this.$message.error("图片上传错误，请稍后重试！");
												},
											},
										}}
										beforeUpload={this.beforeAvatarUpload}>
										<p class="word">修改</p>
									</el-upload>
									<p class="order-type">{orderCenter[index].value}</p>
								</div>
							</el-form-item>
						);
					})}
					<p class="tip blockTip r-mt-30">注1：&nbsp;建议图片分辨率为150px*150px,不超过300K;</p>
					<p class="tip blockTip margin-top-none">注2：&nbsp;支持jpg、png、gif格式图片;</p>
				</el-form>
			</div>
		);
	}
}
